@use "@fukuri-admins/ui/layout" as *;

.wrapper {
  width: 100%;
}

.container {
  width: 100%;
  padding: spacing("16");
}

.buttonContainer {
  display: flex;
  justify-content: flex-end;
  margin-bottom: spacing("16");
}

.tableRow {
  transition: background-color 0.2s ease-out;
  cursor: pointer;
  &:hover {
    background-color: $WhiteHover;
  }
}

.tableCell {
  line-height: 54px;
  font-size: 16px !important;
  font-weight: normal;
  border-bottom: 1px solid $Border;
  &.MuiTableCell-root {
    padding: 0;
  }
}

.descriptionContent {
  min-width: 224px;
  @include typography("Jp/14_W3");
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.tableCellAction {
  line-height: 54px;
  font-size: 16px !important;
  font-weight: normal;
  border-bottom: 1px solid $Border;
  text-align: center;
}

.iconButton {
  &.MuiIconButton-root {
    padding: 4px;
    color: #6C6C79;
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
}

.menuItem {
  @include typography("Jp/14_W3");
  color: text("High") !important;
  padding: 12px;
  min-width: 112px;
}

.menuItemDelete {
  @include typography("Jp/14_W3");
  color: text("Red") !important;
  padding: 12px;
  min-width: 112px;
}
